import { animate, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';

@Component({
  selector: 'app-smash-snackbar',
  templateUrl: './smash-snackbar.component.html',
  styleUrls: ['./smash-snackbar.component.scss'],
  animations: [
    trigger('snackbarAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('.10s ease-in', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('.10s ease-out', style({ opacity: 0 }))
      ])
    ]),
  ]
})
export class SmashSnackbarComponent {

  snackbarDisplayed: boolean;
  constructor() { }

}
